

export function mergeRightToLeft<T extends { id: string }>(left: T[], right: T[],
                                                           merge: (left: T, right: T) => T): T[] {
  const result = left;
  for (const rightItem of right) {
    const foundLeftIndex = result.findIndex((x) => x.id === rightItem.id)
    if (foundLeftIndex < 0) {
      result.push(rightItem);
    } else {
      const foundLeft = result[foundLeftIndex]
      const merged = merge(foundLeft, rightItem)
      result[foundLeftIndex] = merged
    }
  }

  return result;
}
